import React from 'react'
import { Button, LinkUnderline } from '../../components'
import { useNavigate } from 'react-router-dom'
import { AuthContext, AuthContextType } from '../../contexts/authContext'
import { ProfileService } from '../../services'
import { cpfMask } from '../../utils'

export default function Profile(): React.ReactElement {
    const navigate = useNavigate()
    const { setDataUser, getUserInfo } = React.useContext(AuthContext) as AuthContextType

    async function init(): Promise<void> {
        const profileContext = await ProfileService.getDataUser()
        setDataUser(profileContext)
    }

    React.useEffect(() => {
        init()
    }, [])

    const user = getUserInfo()
    return (
        <div className="profile-page">
            <div className="content-user">
                <div className="data-user">
                    <small className="info-user">
                        <strong>Nome</strong> {user?.name || ''}
                    </small>
                    <small className="info-user">
                        <strong>E-mail</strong> {user?.email || ''}
                    </small>
                    <small className="info-user">
                        <strong>CPF</strong> {cpfMask(user?.cpf || '')}
                    </small>
                </div>
                <div className="box-buttons">
                    <Button placeholder="Voltar" onClick={() => navigate(-1)} />
                    <div className="box-links">
                        <LinkUnderline placeholder="Editar perfil" onClick={() => navigate('/edit-profile', { state: user })} />
                        <LinkUnderline placeholder="Alterar senha" onClick={() => navigate('/edit-password', { state: user })} />
                    </div>
                </div>
            </div>
        </div>
    )
}
